import { LoadingSpinner } from "./LoadingSpinner";

export const InlineLoadingSpinner: React.FC = () => {
  return (
    <div className="flex flex-1 items-center justify-center w-full h-full min-h-[120px]">
      <LoadingSpinner />
    </div>
  );
};
